import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import useRenderSong from 'pages/Remixer/hooks/useRenderSong';
import { remixerApi } from 'services/api/remixer';
import { selectProjectTitle } from 'services/store/remixer/selectors';
import { AIGeneratedSong } from 'services/api/entities';
import { analytics, events } from 'services/analytics';

const useExportRemixerSong = () => {
  const { isReady, isRendering, render } = useRenderSong();

  const title = useSelector(selectProjectTitle);

  const [error, setError] = useState<Error | null>(null);

  const [song, setSong] = useState<AIGeneratedSong | null>(null);

  const [uploadSong, { isLoading }] = remixerApi.useUploadSongMutation();

  const isExporting = isRendering || isLoading;

  const exportSong = useCallback(async () => {
    const isSongDownloadable = isReady && title;
    if (!isSongDownloadable) {
      return;
    }

    setSong(null);

    try {
      const { blob, time, effects, duration } = await render();
      analytics.track(
        events.studioRender({
          time,
          effects,
          duration,
          device: {
            logicalProcessors: window.navigator.hardwareConcurrency ?? null,
          },
        })
      );
      const songResponse = await uploadSong(blob).unwrap();
      setSong(songResponse);
    } catch (e) {
      setError(e as Error);
    }
  }, [render, isReady, title, uploadSong]);

  return {
    song,
    isExporting,
    isReady,
    error,
    exportSong,
  };
};

export default useExportRemixerSong;
